import React from "react";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h2 className="footer__title">Made with ❤️ by<h2 className="footer__name"> Harish K </h2></h2> 
                

                {/* <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Projects</a>
                    </li> */}

                    {/* <li>
                        <a href="#about" className="footer__link">About</a>
                    </li> */}
                {/* </ul> */}
            </div>
        </footer>
    )
}

export default Footer